import { i18n } from "@/utils/i18n";

export default {
  namespaced: true,
  state: {
    endpoint: "/client/custom/lamcom/hive/layouts/",
    key: "layout",
    fetchKey: "layouts",
    permissionKey: ""
  },
  mutations: {},
  actions: {},
  getters: {}
};
